<div class="flex align-items-center mb-2">
    <p-iconfield class="w-full">
        <input
            [ngModel]="searchValue"
            (ngModelChange)="onSearch($event)"
            pInputText
            [placeholder]="'common.search' | translate"
            [attr.aria-label]="'common.search' | translate"
            class="w-full" />
        @if (searchValue !== '') {
            <p-inputicon>
                <button
                    type="button"
                    class="searchbar__clear"
                    [attr.aria-label]="'components.searchbar.clear' | translate"
                    (click)="clearInput()">
                    <span class="material-symbols-outlined icon-sm" aria-hidden="true">close</span>
                </button>
            </p-inputicon>
        }
    </p-iconfield>
</div>
